import Vue from "vue";
import Tpl from "./template.vue";

const ToastTpl = Vue.extend(Tpl);

const showToast = (text, duration = 2000) => {
  const toastDom = new ToastTpl({
    el: document.createElement("div"),
    data: function () {
      return {
        text,
        active: false,
      };
    },
  });

  if (!document.getElementById("toast")) {
    document.body.appendChild(toastDom.$el);
    setTimeout(() => {
      toastDom.active = true;
    }, 0);
    setTimeout(() => {
      toastDom.active = false;
    }, duration - 200);
    setTimeout(() => {
      document.body.removeChild(toastDom.$el);
    }, duration);
  }
};

function registryToast() {
  Vue.prototype.$toast = showToast;
}

export default registryToast;
